// src/components/banners/CommunityStatsBanner.jsx

import { useTranslation } from 'react-i18next';

const CommunityStatsBanner = () => {
  const { t } = useTranslation();

  return (
    <section className="community-banner">
      <div className="community-banner__content">
        <h2 className="community-banner__title">
          {t('community_banner.title', 'A growing global ecosystem for perceptual voice data')}
        </h2>

        <p className="community-banner__subtitle">
          {t(
            'community_banner.subtitle',
            'All-Voiced brings together clinicians, educators, researchers, students, dataset owners, and voice technology teams from around the world, contributing to a growing infrastructure for perceptual voice data.'
          )}
        </p>

        <div className="community-banner__stats">
          <div className="community-banner__card">
            <h3>1,800+</h3>
            <p>{t('community_banner.users', 'registered users')}</p>
          </div>

          <div className="community-banner__card">
            <h3>40+</h3>
            <p>{t('community_banner.countries', 'countries represented')}</p>
          </div>

          <div className="community-banner__card">
            <h3>20+</h3>
            <p>{t('community_banner.languages', 'languages spoken')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommunityStatsBanner;